import { render, staticRenderFns } from "./StatisticCardVerticalTotalWorkers.vue?vue&type=template&id=5b6d4a39&"
import script from "./StatisticCardVerticalTotalWorkers.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalTotalWorkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports